export var TypeActionPackageInfo;
(function (TypeActionPackageInfo) {
    TypeActionPackageInfo["RequestPurchaseInfo"] = "ActionPackageInfo > RequestPurchaseInfo";
    TypeActionPackageInfo["SetPurchaseInfo"] = "ActionPackageInfo > SetPurchaseInfo";
    TypeActionPackageInfo["SetPackageInfo"] = "ActionPackageInfo > SetPackageInfo";
    TypeActionPackageInfo["Purchased"] = "ActionPackageInfo > Purchased";
})(TypeActionPackageInfo || (TypeActionPackageInfo = {}));
export var actionRequestPurchasePackageInfo = function (ids) { return ({
    ids: ids,
    type: TypeActionPackageInfo.RequestPurchaseInfo,
}); };
export var actionSetPurchasePackageInfo = function (props) { return ({
    packages: props ? props.packages : [],
    type: TypeActionPackageInfo.SetPurchaseInfo,
}); };
export var actionSetPackageInfo = function (packages) { return ({
    packages: packages,
    type: TypeActionPackageInfo.SetPackageInfo,
}); };
export var actionPurchasePackageInfoPurchased = function (props) { return ({
    packageId: props,
    type: TypeActionPackageInfo.Purchased,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/info/purchase-packages/actionSetPurchasePackageInfo.ts
// module id = 247
// module chunks = 3